module.exports = __webpack_public_path__ + "static/media/jacuzzi.6a0fc3f9.png";